import { Directive, AfterViewInit, ElementRef } from '@angular/core';

@Directive({
    selector: '[autofocus]'
})
export class AutofocusDirective implements AfterViewInit {
   
    constructor(private element: ElementRef) {
    }
   
    ngAfterViewInit() {
        this.element.nativeElement.focus();
    } 
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/autofocus.directive.ts